import { useLanguage } from "@/context/language-context/LanguageContext";

export const useDate = () => {
  const { language } = useLanguage();
  const locale = language === "es" ? "es-ES" : "en-GB";

  const formatDate = (isoDate: string) => {
    const date = new Date(isoDate);
    if (isNaN(date.getTime()))
      return language === "es" ? "Fecha inválida" : "Invalid date";
    return new Date(date).toLocaleDateString(locale, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const getDaysSince = (isoDate: string): string => {
    const date = new Date(isoDate);
    if (isNaN(date.getTime()))
      return language === "es" ? "Fecha inválida" : "Invalid date";

    const today = new Date();
    // Elimina la hora para comparar solo fechas
    const diffTime = today.setHours(0, 0, 0, 0) - date.setHours(0, 0, 0, 0);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    let daysLabel = language === "es" ? "día" : "day";
    if (diffDays !== 1) daysLabel += "s";
    return `${diffDays} ${daysLabel}`;
  };

  const getTotalDays = (isoDateSince: string, isoDateUntil: string): string => {
    const dateSince = new Date(isoDateSince);
    const dateUntil = new Date(isoDateUntil);
    if (isNaN(dateSince.getTime()))
      return language === "es" ? "Fecha inválida" : "Invalid date";
    if (isNaN(dateUntil.getTime()))
      return language === "es" ? "Fecha inválida" : "Invalid date";

    const diffTime =
      dateUntil.setHours(0, 0, 0, 0) - dateSince.setHours(0, 0, 0, 0);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    let daysLabel = language === "es" ? "día" : "day";
    if (diffDays !== 1) daysLabel += "s";
    return `${diffDays} ${daysLabel}`;
  };

  const transforDateToSearch = (spanishDate: string): string => {
    const splittedDate = spanishDate.split("/");
    return `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
  };

  return { formatDate, getDaysSince, getTotalDays, transforDateToSearch };
};
